import { translate } from "../../components/Language/Translate";

class UserSchema {
  constructor(companyId, userStatus) {
    this.userStatus = userStatus;
    this.companyId = companyId;
    this.fields = {
      salutation: {
        initialValue: "Herr",
        label: translate("Salutation"),
        fieldType: "select",
        type: "text",
        options: [
          { key: "Herr", value: translate("Herr") },
          { key: "Frau", value: translate("Frau") },
        ],
        required: true,
      },

      title: {
        initialValue: "",
        label: translate("Title"),
        required: false,
        validation: { maxLength: 10, noNumbers: true },
        fieldType: "text",
        type: "text",
      },
      firstName: {
        initialValue: "",
        label: translate("First Name"),
        required: true,
        validation: { minLength: 2, maxLength: 40, noNumbers: true },
        fieldType: "text",
        type: "text",
      },
      lastName: {
        initialValue: "",
        label: translate("Last Name"),
        required: true,
        validation: { minLength: 2, maxLength: 40, noNumbers: true },
        fieldType: "text",
        type: "text",
      },
      functions: {
        initialValue: "",
        label: translate("function"),
        fieldType: "text",
        type: "text",
      },
      email: {
        initialValue: "",
        label: translate("Email"),
        required: true,
        validation: { minLength: 8, maxLength: 50, isEmail: true },
        fieldType: "text",
        type: "email",
      },
      phone: {
        initialValue: "",
        label: translate("Phone"),
        required: false,
        validation: { maxLength: 40 },
        fieldType: "text",
        type: "text",
      },
      mobile: {
        initialValue: "",
        label: translate("Mobile"),
        required: false,
        validation: { maxLength: 40 },
        fieldType: "text",
        type: "text",
      },
      note: {
        initialValue: "",
        label: translate("Note"),
        required: false,
        fieldType: "textarea",
        type: "text",
      },
      userStatus: {
        initialValue: `#${companyId}|user`,
        label: translate("User Status"),
        fieldType: "select",
        type: "text",
        options: UserSchema.getStatusOptions(this.companyId, this.userStatus),
        required: true,
      },
      password: {
        initialValue: "",
        label: translate("Password"),
        fieldType: "text",
        type: "password",
        required: true,
        validation: { minLength: 8 },
      },
      confirmPassword: {
        initialValue: "",
        label: translate("Confirm Password"),
        fieldType: "text",
        type: "password",
        required: true,
        validation: { minLength: 8, mustBeEqualTo: "password" },
      },
    };
  }

  static getStatusOptions(companyId, userStatus) {
    // console.log({ companyId, userStatus });
    const developer = "developer";
    const mainAdmin = `#${companyId}|mainAdmin`;
    const admin = `#${companyId}|admin`;
    const subAdmin = `#${companyId}|subAdmin`;
    const user = `#${companyId}|user`;

    const isDeveloper = userStatus === "developer";
    const isMainAdmin = isDeveloper || userStatus?.includes("mainAdmin");
    const isAdmin = isMainAdmin || userStatus === admin;
    const isSubAdmin = isAdmin || userStatus === subAdmin;
    const isUser = isSubAdmin || userStatus === user;

    // console.log({ developer, mainAdmin, admin, subAdmin, user });
    // console.log({ isDeveloper, isMainAdmin, isAdmin, isSubAdmin, isUser });

    // let level = 0;
    // level = [subAdmin].includes(userStatus) ? 10 : level;
    // level = [admin].includes(userStatus) ? 20 : level;
    // level = [mainAdmin].includes(userStatus) ? 100 : level;
    // level = [developer].includes(userStatus) ? 200 : level;

    // console.log({level});

    let options = [];
    if (isSubAdmin) options.push({ key: user, value: "User (nur Leserechte)" });
    if (isAdmin)
      options.push({
        key: subAdmin,
        value: "Sub-Administrator für diese Schule (Schreibrechte)",
      });
    if (isAdmin)
      options.push({
        key: admin,
        value:
          "Administrator für diese Schule (Schreibrechte, Einsatz von Admins und Subadmins)",
      });
    if (isMainAdmin)
      options.push({
        key: mainAdmin,
        value:
          "Administrator für alle Schulen (Schreibrechte, Einsatz von Admins und Subadmins)",
      });
    if (isDeveloper) options.push({ key: developer, value: "Entwickler" });
    // if(level >= 10)options.push({key:user, value:"User (nur Leserechte)"})
    // if(level >= 20)options.push({key:subAdmin, value:"Sub-Administrator für diesen Schule (Schreibrechte)"})
    // if(level >= 20)options.push({key:admin, value:"Administrator für diesen Schule (Schreibrechte, Einsatz von Admins und Subadmins)"})
    // if(level >= 100)options.push({key:mainAdmin, value:"Administrator für alle Schule (Schreibrechte, Einsatz von Admins und Subadmins)"})
    // if(level >= 200)options.push({key:developer, value:"Entwickler"})
    // console.log({ options });
    return options;
  }
}
export default UserSchema;
